import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Checkbox } from 'office-ui-fabric-react/lib/Checkbox';

import { localizable } from 'components/Localization';
import SaleInfo from './SaleInfo';

const TocSection = styled.span`
  a {
    color: ${(props) => props.theme.palette.themePrimary};
  }
`;

@inject('app', 'user')
@localizable
@observer
class DuplicateStep1 extends Component {
  componentDidMount() {
    const { onValidChanged } = this.props;
    onValidChanged(false);
  }

  handleOpenToc = (e, page) => {
    const { user, app } = this.props;
    e.preventDefault();
    e.stopPropagation();

    // HACK-ing
    var url = `/content/${page}?locale=${user.claims.locale}`;
    if (app.config.tenant.startsWith('propnow'))
      url =
        window.location.origin.replace('://app.', `://${user.claims.tenant}.`) +
        url;

    window.open(url);
  };

  handleTocChange = (_, isChecked) => {
    const { onValidChanged } = this.props;
    onValidChanged(isChecked);
  };

  render() {
    var { app, store, t } = this.props;

    return (
      <Fragment>
        <ul className="hint">
          <li>{t('hint1')}</li>
          <li>{t('hint2')}</li>
        </ul>

        <div className="control">
          <div style={{ paddingBottom: '1em' }}>
            <h2>{t('Duplicating sale')}</h2>
            <SaleInfo store={store} t={t} />
          </div>
          <Checkbox
            onChange={this.handleTocChange}
            label={t('I agree with terms and conditions')}
            onRenderLabel={() => {
              return (
                <TocSection theme={app.theme}>
                  <FormattedMessage
                    id="SaleCreatePanel::i_agree_to_the_link"
                    values={{
                      agbs: (
                        <a onClick={(e) => this.handleOpenToc(e, 'agb')}>
                          {t('agbs')}
                        </a>
                      ),
                      dataprotection: (
                        <a
                          onClick={(e) =>
                            this.handleOpenToc(e, 'datenschutzerklaerung')
                          }
                        >
                          {t('dataprotection')}
                        </a>
                      ),
                      avv: (
                        <a onClick={(e) => this.handleOpenToc(e, 'avv')}>
                          {t('avv')}
                        </a>
                      ),
                    }}
                  />
                </TocSection>
              );
            }}
          />
        </div>
      </Fragment>
    );
  }
}

export default DuplicateStep1;



// WEBPACK FOOTER //
// ./src/app/containers/SaleWizard/Duplicate/Step1.jsx